import React from "react";
import { useTheme } from "@mui/material";

const ShareIcon = ({ stroke }) => {
  const theme = useTheme();

  return (<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.34778 11.208L12.66 14.392M12.6522 5.608L7.34778 8.792M17 4.4C17 5.72548 15.9553 6.8 14.6667 6.8C13.378 6.8 12.3333 5.72548 12.3333 4.4C12.3333 3.07452 13.378 2 14.6667 2C15.9553 2 17 3.07452 17 4.4ZM7.66667 10C7.66667 11.3255 6.622 12.4 5.33333 12.4C4.04467 12.4 3 11.3255 3 10C3 8.67452 4.04467 7.6 5.33333 7.6C6.622 7.6 7.66667 8.67452 7.66667 10ZM17 15.6C17 16.9255 15.9553 18 14.6667 18C13.378 18 12.3333 16.9255 12.3333 15.6C12.3333 14.2745 13.378 13.2 14.6667 13.2C15.9553 13.2 17 14.2745 17 15.6Z" stroke={stroke || theme.palette.primary[500]} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
  );
};

export default ShareIcon;

